import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import FlowRunDisplay from '../FlowRunDisplay';
import { FlowModel } from '../../../types/flow.types';
import { EntityDetailCardSection } from '../EntityDetailCard';

interface Props {
  flowModel: FlowModel;
  isLoading?: boolean;
  isSuccess?: boolean;
  accountName: string;
  timezone: string;
}

const FlowHeaderLastRunSection: React.FC<Props> = ({
  flowModel,
  isLoading,
  accountName,
  timezone,
}) => (
  <EntityDetailCardSection data-cy="flow-header-last-run-section">
    <Typography variant="overline" fontWeight={900}>
      LAST RUN
    </Typography>
    {isLoading ? (
      <Skeleton variant="text" width="100%" />
    ) : (
      <a
        href={`/${accountName}/flows/${flowModel['name']}/syncs/${flowModel?.['last-run']?.['id']}`}
        style={{
          textDecoration: 'none',
          color: '#3174AB',
          fontWeight: 'bold',
        }}
      >
        <FlowRunDisplay
          flowRun={flowModel?.['last-run'] || null}
          nextOrLastRun="last"
          timezone={timezone}
        />
      </a>
    )}
  </EntityDetailCardSection>
);

export default FlowHeaderLastRunSection;
